import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { take } from 'rxjs/operators';
import { QueuesService } from '@app/_core/services/queues.service';
import { ComposeMailComponent } from '../compose-mail/compose-mail.component';
import { FormDataService } from '@app/_core/services/form-data.service';

@Component({
  selector: 'app-view-email',
  templateUrl: './view-email.component.html',
  styleUrls: ['./view-email.component.scss'],
})
export class ViewEmailComponent implements OnInit {
  @Input() heading: string = 'View Original Email';
  @Input() emailData: any = null;

  sanitizedBody: SafeHtml = '';
  toAddresses: string[] = [];
  ccAddresses: string[] = [];
  bccAddresses: string[] = [];
  attachments: any[] = [];
  emailChain: any[] = [];

  constructor(
    public bsModalRef: BsModalRef,
    private sanitizer: DomSanitizer,
    private queuesService: QueuesService,
    private modalService: BsModalService,
    private formDataService: FormDataService,
    @Inject(APP_BASE_HREF) public baseHref: string,
  ) {}

  ngOnInit(): void {
    if (this.emailData) {
      this.processEmailData();
    }
  }

  private processEmailData(): void {
    this.sanitizedBody = this.sanitizer.bypassSecurityTrustHtml(this.emailData.BodyText || '');
    this.toAddresses = this.splitAddresses(this.emailData.To);
    this.ccAddresses = this.splitAddresses(this.emailData.CC);
    this.bccAddresses = this.splitAddresses(this.emailData.BCC);
    this.attachments = this.emailData.Attachments || [];
    this.emailChain = this.emailData.email_chain || [];
  }

  close(): void {
    this.bsModalRef.hide();
  }

  reply(): void {
    this.openComposeModal('reply', 'Reply');
  }

  replyAll(): void {
    this.openComposeModal('replyAll', 'Reply All');
  }

  forward(): void {
    this.openComposeModal('forward', 'Forward');
  }

  private openComposeModal(mode: 'reply' | 'replyAll' | 'forward', heading: string): void {
    const initialState = { Heading: heading, mode, originalEmail: this.emailData };
    const config: ModalOptions = { class: 'compose-mail modal-dialog-centered', backdrop: true, initialState };
    this.bsModalRef.onHidden.pipe(take(1)).subscribe(() => {
      this.modalService.show(ComposeMailComponent, config);
    });
    this.bsModalRef.hide();
  }

  downloadAttachment(fileUrl: any): void {
    console.log('Download attachment:', fileUrl);
    this.formDataService.getFile(fileUrl).subscribe(res => {
      console.log('FileData', res);
      const src = `data:${res?.MimeType};base64,${res?.result}`;
      const link = document.createElement('a');
      link.href = src;
      link.download = res?.fileName;
      link.click();
      link.remove();
    });
  }

  formatBytes(bytes: number): string {
    if (!bytes || bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }

  private splitAddresses(raw: string): string[] {
    if (!raw) return [];
    return raw.split(/[;,]/).map(a => a.trim()).filter(a => a.length > 0);
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${day}-${month}-${year} ${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
  }
}
